﻿import {GameCategory, GameScreen, MoneyType} from "../../enums";
import {Core} from "../../Base/Core";
import {UICommonPopup} from "../Tools/Base/UICommonPopup";
import {Utils} from "../../Utils/Utils";
import {UILabeledIcon} from "../Tools/Base/UILabeledIcon";

export class UIVipDailyReward extends UICommonPopup {
    Awake() {
        super.Awake({
            skin: "orange",
            title: Core.Localizator.Get("vip_daily_reward"),
            closeButton: true,
        });

        this.onSomethingPurchased = this.onSomethingPurchased.bind(this);

        this.rewardValueField = this.content.addChild(
            new UILabeledIcon({
                icon: "ico-diamond",
                label: "",
            })
        );

        Core.Store.on("Purchased", this.onSomethingPurchased);
    }

    onSomethingPurchased(product) {
        if (product.id == "vip") {
            Core.WaitBefore(0.2, () => this.Check());
        }
    }

    fitLayout(viewport = Core.app.viewport) {
        this.setPopupSize(viewport.width * 0.8, viewport.width * 0.4);
        super.fitLayout(viewport);

        let contentRect = this.getContentSize();
        let rect = contentRect.clone().pad(-contentRect.width * 0.1, -contentRect.height * 0.2);
        rect.y += contentRect.height * 0.2;
        this.rewardValueField.fitLayout(rect);
    }

    Show() {
        this.rewardValueField.label = Utils.Format("+{0}", Core.GameData.AppStore.vip.hardMoneyDailyBonus);
        super.Show();
    }

    Check() {
        if (!Core.Store.VipActive) return;
        if (!Core.Time.Initialized) return;
        if (!Core.Player) return;
        if (!Core.Player.Initialized) return;
        if (Core.Player.Timers.IsVipTakenToday()) return;

        Core.Player.AddMoney(
            MoneyType.Hard,
            Core.GameData.AppStore.vip.hardMoneyDailyBonus,
            GameCategory.empty,
            GameScreen.vip,
            "vip_daily"
        );
        Core.Player.Timers.OnVipTaken();
        Core.UI.bank.Hide();
        this.Show();

    }
}
